<template>
  <div id="geo-wrapper">
    <div class="modal fade" id="geo" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title h3" v-html="$translate('Phywe::Template.PopupHeader')">
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body">
            <div class="my-5 d-flex justify-content-center">
              <img src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/PHYWE_Logo_mit_Claim_CMYK.svg" style="max-width:270px;">
            </div>
            <div v-html="$translate('Phywe::Template.PopupBody', {'country': country })">
            </div>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <button class="btn btn-primary flex-fill" v-html="$translate('Phywe::Template.PopupButton')" @click="goto()">
              </button>
              <a class="btn flex-fill" data-dismiss="modal" aria-hidden="true" href="#" v-html="$translate('Phywe::Template.PopupLink')">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ModalService from "../services/ModalService";

export default
{
  data: function()
  {
    return {
      country:null,
      link:null
    }
  },
  created:function()
  {
    if(localStorage.getItem('country')==undefined || localStorage.getItem('country')=='undefined')
    {
      this.gocheck()
    }
  },
  methods:
  {
    goto()
    {
      window.location.href = this.link;
    },
    gocheck: function()
    {
      let _self = this;
      $.ajax({
        type: 'GET',
        url: '/'+App.language+'/destination/',
        success: function (response)
        {
          if(response)
          {
            if(response.hasOwnProperty('redirectnow'))
            {
              window.location.href = response.goToShop;
            }
            else
            {
              //localStorage.setItem('lang', data.countryCode);
              //localStorage.setItem('continent', data.continentCode);
              localStorage.setItem('country',response.country);
              _self.country = response.country;
              _self.link    = response.goToShop;
              ModalService.findModal(document.getElementById("geo-wrapper")).show();
            }
          }
          else
          {
            localStorage.setItem('country', 'match');
          }
        },
        error: function (jqXHR, textStatus, errorThrown)
        {
          console.error(errorThrown);
        }
      });
    }
  }
}
</script>